import React from 'react'
import { connect } from 'react-redux'
import DeletePlanDeEmbarqueBodega from './DeletePlanDeEmbarqueBodega'
import EdicionPlanDeEmbarqueBodega from './EdicionPlanDeEmbarqueBodega'
import { deleteDellatePlanDeEmbarqueBodega } from '../../actions/PlanDeEmbarqueActions'

function OperacionesPlanDeEmbarqueBodega (props) {
  const { detalleBodega } = props

  const handleDelete = () => {
    props.deleteDellatePlanDeEmbarqueBodega(detalleBodega.fechaDeReferencia, detalleBodega.bodega, detalleBodega.buque, detalleBodega.paisDestino)
  }

  return (
    <div style={{ display: 'flex' }}>
      <DeletePlanDeEmbarqueBodega handleDelete={handleDelete} />
      <EdicionPlanDeEmbarqueBodega detalle={detalleBodega} />
    </div>
  )
}

const mapActionsToProps = {
  deleteDellatePlanDeEmbarqueBodega
}

const withRedux = connect(null, mapActionsToProps)

export default withRedux(OperacionesPlanDeEmbarqueBodega)
